import { isEmptyOrSpaces } from 'utils/validate';

export const isValidOrgInfo = organization => {
  const { name, address } = organization || {};
  return !isEmptyOrSpaces(name) && !isEmptyOrSpaces(address);
};
